import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import LinkedinCardsGrid from "presentation/components/LinkedinCards/LinkedinCardsGrid";
import LinkedinRequestsGrid from "presentation/components/LinkedinRequests/LinkedinRequestsGrid";
import LinkedinCardsDashboard from "presentation/components/LinkedinCards/LinkedinCardsDashboard";
import LinkedinCardsRanking from "presentation/components/LinkedinCards/LinkedinCardsRanking";
import LinkedinBlacklistGrid from "presentation/components/LinkedinBlacklist/LinkedinBlacklistGrid";
import LinkedinLocationMappingGrid from "presentation/components/LinkedinLocationMapping/LinkedinLocationMappingGrid";
import { TabPanel, TabView } from "primereact/tabview";

const LinkedinCardsGridPage = () => {
  const { isLoading } = usePermissionCheck({
    requiredFunction: "openPositions",
  });
  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Posições Abertas" />
      <TabView>
        <TabPanel header="Dashboard" leftIcon="pi pi-chart-bar mr-2">
          <LinkedinCardsDashboard />
        </TabPanel>
        <TabPanel header="Ranking Dinâmico" leftIcon="pi pi-sliders-h mr-2">
          <LinkedinCardsRanking />
        </TabPanel>
        <TabPanel header="Pesquisa" leftIcon="pi pi-search mr-2">
          <LinkedinRequestsGrid />
        </TabPanel>
        <TabPanel header="Posições" leftIcon="pi pi-book mr-2">
          <LinkedinCardsGrid />
        </TabPanel>
        <TabPanel header="Blacklist" leftIcon="pi pi-ban mr-2">
          <LinkedinBlacklistGrid />
        </TabPanel>
        <TabPanel header="Padronização de Locais" leftIcon="pi pi-map-marker mr-2">
          <LinkedinLocationMappingGrid />
        </TabPanel>
      </TabView>
    </div>
  );
};
export default LinkedinCardsGridPage;
